import { buildPath, buildTemplatePath, Page, PageRoute } from "@compass/core";
import { Permission, SurveyExportResource } from "generated/openApi";
import "moment-timezone";
import { useEffect, useState } from "react";
import ApiService from "services/apiService";
import { SurveyExportBody } from "./SurveyExportBody";
import { SurveyExportHeader } from "./SurveyExportHeader";

const routeName = "export";

export const surveyExportPageRoute: PageRoute = {
  handle: "Export",
  templatePath: buildTemplatePath(routeName),
  getPath: () => buildPath(routeName),
};

// TODO
const ROOT_PERMISSION: Permission = Permission.Form;

export const SurveyExportPage = () => {
  const [viewResource, setViewResource] = useState<SurveyExportResource>({} as SurveyExportResource);
  const [surveyId, setSurveyId] = useState<number>();
  const [exportTypeId, setExportTypeId] = useState<number>();

  const getExportResource = () => {
    ApiService.surveyExport.getSurveyExportResource().then((response) => {
      setViewResource(response);
      setExportTypeId(response.exportTypes![0].id);
    });
  };

  const onChangeSurveyId = (surveyId) => {
    setSurveyId(surveyId);
  };

  const onChangeExportType = (exportTypeId) => {
    setExportTypeId(exportTypeId);
  };

  useEffect(() => {
    getExportResource();
  }, []);

  return (
    <Page
      header={
        <SurveyExportHeader handle={surveyExportPageRoute.handle} surveyId={surveyId} exportTypeId={exportTypeId} />
      }
    >
      <SurveyExportBody
        surveyId={surveyId}
        exportTypeId={exportTypeId}
        setSurveyId={onChangeSurveyId}
        setExportTypeId={onChangeExportType}
        viewResource={viewResource}
      />
    </Page>
  );
};
